import { render, staticRenderFns } from "./selling.vue?vue&type=template&id=65c318b0&scoped=true"
import script from "./selling.vue?vue&type=script&lang=js"
export * from "./selling.vue?vue&type=script&lang=js"
import style0 from "./selling.vue?vue&type=style&index=0&id=65c318b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c318b0",
  null
  
)

export default component.exports